// Libs
// Components, Layouts, Pages
// Others
// Styles, images, icons

type Props = {};

const NotFoundPage = (props: Props) => {
  return <>Page Not Found</>;
};

export default NotFoundPage;
